{
  "APP_NAME": "EliwellAIR.web",
  "About": "About",
  "Hello world !": "Hello world !",
  "Home": "Home",
  "Logged in as": "Logged in as",
  "Login": "Login",
  "Logout": "Logout",
  "Password": "Password",
  "Password is required": "Password is required",
  "Username": "Username",
  "Username is required": "Username is required",
  "Username or password incorrect.": "Username or password incorrect.",
  "Remember me": "Remember me",
  "Version": "Version",
  "Profile Update": "Profile Update",
  "Change Password": "Change Password",
  "Change Email": "Change Email",
  "Dashboard": "Dashboard",
  "Manage": "Manage",
  "Filter": "Filter",
  "Search": "Search",
  "Alarms": "Alarms",
  "Warnings": "Warnings",
  "Users": "Users",
  "Coolers": "Coolers",
  "Active License": "Active License",
  "License Expired": "License Expired",
  "Grace Period": "Grace Period",
  "Tenant Users": "Tenant Users",
  "Change Passowrd": "Change Passowrd",
  "Rules": "Rules",
  "License Expires On": "License Expires On",
  "Report": "Report",
  "Tenant List": "Tenant List",
  "Add Tenant": "Add Tenant",
  "Erp No": "Erp No",
  "Tenant": "Tenant",
  "License End Date": "License End Date",
  "Tenant Email": "Tenant Email",
  "ERP Number": "ERP Number",
  "Maximum number of coolers": "Maximum number of coolers",
  "License Expiration": "License Expiration",
  "Tenant Details": "Tenant Details",
  "TENANT EMAIL": "TENANT EMAIL",
  "COOLERS": "COOLERS",
  "Expire": "Expire",
  "GEO LOCATION": "GEO LOCATION",
  "ERP NO": "ERP NO",
  "UPDATE": "UPDATE",
  "Disable Tenant": "Disable Tenant",
  "Move Coolers": "Move Coolers",
  "Do you really want to disable": "Do you really want to disable",
  "Cooler List": "Cooler List",
  "Search works on COOLER, COUNTRY, TAG/ALIAS columns only": "Search works on COOLER, COUNTRY, TAG/ALIAS columns only",
  "Cooler": "Cooler",
  "Last Connected": "Last Connected",
  "Country": "Country",
  "Tag/Alias": "Tag/Alias",
  "User Information": "User Information",
  "Add New User": "Add New User",
  "Search works on ROLE, EMAIL, CREATE ALARMS, ACCESS TO columns only": "Search works on ROLE, EMAIL, CREATE ALARMS, ACCESS TO columns only",
  "Role": "Role",
  "Email": "Email",
  "Create Alarms": "Create Alarms",
  "Access To": "Access To",
  "Add User Details": "Add User Details",
  "Edit User Details": "Edit User Details",
  "All Countries Selected": "All Countries Selected",
  "Yes": "Yes",
  "No": "No",
  "Alarm Information": "Alarm Information",
  "Search works on UID, STATUS, COOLER, GEO LOCATION, RULE, ALARM TYPE, RESOURCE columns only": "Search works on UID, STATUS, COOLER, GEO LOCATION, ALARM TYPE, RESOURCE columns only",
  "UID": "UID",
  "Geo Location": "Geo Location",
  "Status": "Status",
  "Alarm Type": "Alarm Type",
  "Rule": "Rule",
  "Resource": "Resource",
  "Alarm Rules": "Alarm Rules",
  "Add New Rule": "Add New Rule",
  "Search works on ID, STATUS, ALARM NAME, SEVERITY columns only": "Search works on ID, STATUS, ALARM NAME, SEVERITY columns only",
  "All": "All",
  "All Controller with Geo Location": "All Controller with Geo Location",
  "ID": "ID",
  "Alarm Name": "Alarm Name",
  "Limit": "Limit",
  "Severity": "Severity",
  "BACK": "BACK",
  "Last Connected On": "Last Connected On",
  "Resources Data": "Resources Data",
  "Tag Name": "Tag Name",
  "Update Tag or Alias Name": "Update Tag or Alias Name",
  "Update": "Update",
  "Export": "Export",
  "DAY": "DAY",
  "WEEK": "WEEK",
  "MONTH": "MONTH",
  "Loading latest telemetry data ... ": "Loading latest telemetry data ... ",
  "Loading telemetry data ... ": "Loading telemetry data ...",
  "No Data to display": "No Data to display",
  "Resources": "Resources",
  "Min": "Min",
  "Max": "Max",
  "Value": "Value",
  "Unit": "Unit",
  "Timestamp": "Timestamp",
  "Save": "Save",
  "Cancel": "Cancel",
  "Save and Apply": "Save and Apply",
  "Move": "Move",
  "Add Alarm Details": "Add Alarm Details",
  "Update Alarm Details": "Update Alarm Details",
  "Controller": "Controller",
  "Notified Email To": "Notified Email To",
  "Apply To": "Apply To",
  "Max Distance": "Max Distance",
  "Controller Name": "Controller Name",
  "All Controller In": "All Controller In",
  "High": "High",
  "Low": "Low",
  "Parameter": "Parameter",
  "Select Controller": "Select Controller",
  "Select Controllers": "Select Controllers",
  "Select Resource": "Select Resource",
  "Success Message": "Success Message",
  "Error": "Error",
  "Are you sure to Delete User?": "Are you sure to Delete User?",
  "User deleted successfully.": "User deleted successfully.",
  "Invalid Email": "Invalid Email",
  "Email field should not be empty.": "Email field should not be empty.",
  "Email entered is not a valid email.": "Email entered is not a valid email.",
  "Invalid Role": "Invalid Role",
  "Select a role.": "Select a role.",
  "Updated successfully.": "Updated successfully.",
  "added successfully.": "added successfully.",
  "Error occurred while adding user, please try again.": "Error occurred while adding user, please try again.",
  "Invalid Controller": "Invalid Controller",
  "Select a Controller": "Select a Controller",
  "Invalid Resource": "Invalid Resource",
  "Select a Resource": "Select a Resource",
  "Invalid Min Value": "Invalid Min Value",
  "Enter a valid Min Value.": "Enter a valid Min Value.",
  "Invalid Max Value": "Invalid Max Value",
  "Enter a valid Max Value.": "Enter a valid Max Value.",
  "Invalid Max Distance Value": "Invalid Max Distance Value",
  "Enter a valid Max Distance Value.": "Enter a valid Max Distance Value.",
  "Invalid Notify Mail Ids": "Invalid Notify Mail Ids",
  "Enter valid mail Ids.": "Enter valid mail Ids.",
  "Select a valid controller in apply to section.": "Select a valid controller in apply to section.",
  "Invalid Countries": "Invalid Countries",
  "Select one or more countries apply to section.": "Select one or more countries apply to section.",
  "Invalid Rule Name": "Invalid Rule Name",
  "Enter a valid rule name.": "Enter a valid rule name.",
  "added successfully": "added successfully",
  "updated successfully": "updated successfully",
  "Error occurred while adding/updating Rule, please try again.": "Error occurred while adding/updating Rule, please try again.",
  "Activated successfully": "Activated successfully",
  "Deactivated successfully": "Deactivated successfully",
  "Deleted successfully.": "Deleted successfully.",
  "Are you sure to Delete Rule?": "Are you sure to Delete Rule?",
  "Invalid TenantName": "Invalid TenantName",
  "Tenant Name field should not be empty.": "Tenant Name field should not be empty.",
  "Invalid ERP No": "Invalid ERP No",
  "ERP NO field should not be empty.": "ERP NO field should not be empty.",
  "Invalid CoolersCount": "Invalid CoolersCount",
  "Please enter valid Coolers": "Please enter valid Coolers",
  "Invalid Cooler Value": "Invalid Cooler Value",
  "Enter a valid Cooler Number Value.": "Enter a valid Cooler Number Value.",
  "Invalid Expiry Date": "Invalid Expiry Date",
  "Please select Expiry Date": "Please select Expiry Date",
  "Tenant added successfully.": "Tenant added successfully.",
  "Error occurred while adding tenant, please try again.": "Error occurred while adding tenant, please try again.",
  "Tenant Updated successfully.": "Tenant Updated successfully.",
  "Error occurred while updating tenant, please try again.": "Error occurred while updating tenant, please try again.",
  "Reports": "Reports",
  "Search works on Erp No, Tenant, Geo Location only": "Search works on Erp No, Tenant, Geo Location only",
  "Update Tenant": "Update Tenant",
  "Select Expiry License Date": "Select Expiry License Date",
  "Registered Tenant": "Registered Tenant",
  "Registered Users": "Registered Users",
  "Users under Tenant": "Users under Tenant",
  "Renewal notification sent to Tenant": "Renewal notification sent to Tenant",
  "Number of coolers under Tenant": "Number of coolers under Tenant",
  "Date": "Date",
  "Choose Format": "Choose Format",
  "Generate Report": "Generate Report",
  "Select": "Select",
  "Active Alarms": "Active Alarms",
  "Associated Resources": "Associated Resources",
  "Associated Users": "Associated Users",
  "Coolers List": "Coolers List",
  "Device": "Device",
  "User Device Information": "User Device information",
  "Mobile Name": "Mobile Name",
  "Mobile Model": "Mobile Model",
  "Legal": "Legal",
  "Privacy Policy": "Privacy Policy",
  "Copyright": "Copyright",
  "No Records found": "No Records found",
  "Billing Address": "Billing Address",
  "Search works on Email, Mobile Name, Mobile Model": "Search works on Email, Mobile Name, Mobile Model",
  "Are you sure to Delete ?": "Are you sure to Delete ?",
  "No results found!": "No results found!",
  "Select Country": "Select Country",
  "Start Date": "Start Date",
  "End Date": "End Date",
  "Select Start Date": "Select Start Date",
  "Select End Date": "Select End Date",
  "Invalid Start Date": "Invalid Start Date",
  "Invalid End Date": "Invalid End Date",
  "Invalid Controllers List": "Invalid Controllers List",
  "Please wait report is getting ready for Download": "Please wait report is getting ready for Download",
  "downloadFaild": "Faild to download",
  "Format": "Format",
  "Controllers": "Controllers",
  "Downloads in Progress": "Downloads in Progress",
  "Do you agree?": "Do you agree?",
  "All the files downloaded Successfully": "All the files downloaded Successfully",
  "No files found": "No files found",
  "You have cancelled the Downloads": "You have cancelled the Downloads",
  "Warning": "Warning",
  "Driver Manager": "Driver Manager",
  "Driver File Name": "Driver File Name",
  "Mask": "Mask",
  "Uploaded By": "Uploaded By",
  "Uploaded On": "Uploaded On",

  "Are you sure to Delete Driver?": "Are you sure to Delete Driver?",
  "Please upload a valid file": "Please upload a valid file",
  "Driver file already exists": "Driver file already exists",
  "Are you sure you want to Overwrite?": "Are you sure you want to Overwrite?",
  "Download Success!": "Download Success!",
  "File Deleted Successfully": "File Deleted Successfully",
  "Trying to upload a non verified driver": "Trying to upload a non verified driver",
  "Driver File Uploaded": "Driver File Uploaded",
  "File name should not be more than 50 characters": "File name should not be more than 50 characters",
  "Action": "Action",
  "Bad Request": "Bad Request",
  "Invalid input fields": "Invalid input fields",
  "Invalid Tag Name": "Invalid Tag Name",
  "Coolers by Country": "Coolers by Country",
  "Enable/Disable": "Enable/Disable",
  "Actions": "Actions",
  "Controller Model": "Controller Model",
  "Selected Resources Data": "Selected Resources Data",
  "Last 24Hr": "Last 24Hr",
  "View Data": "View Data",
  "Note: Maximum of 8 resources are allowed to view data": "Note: Maximum of 8 resources are allowed to view data",
  "Get Data": "Get Data",
  "Until": "Until",
  "Tag Updated Successfully": "Tag Updated Successfully",
  "Add Tag Name..": "Add Tag Name..",
  "Select Tenant": "Select Tenant",
  "Tenant Disabled Successfully.": "Tenant Disabled Successfully.",
  "Cooler moved successfully.": "Cooler moved successfully.",
  "Unknown error occurred, Please try again.": "Unknown error occurred, Please try again.",
  "No cooler/coolers availabe to move": "No cooler/coolers availabe to move",
  "The target Tenant does not have enough space for the new coolers": "The target Tenant does not have enough space for the new coolers",
  "Tenant is not selected": "Tenant is not selected",
  "Please select Tenant": "Please select Tenant",
  "Select Countries": "Select Countries",
  "Country List": "Country List",
  "Controller List": "Controller List",
  "Close": "Close",
  "Disable": "Disable",
  "Note: Once disabled you can not enable again.": "Note: Once disabled you can not enable again.",
  "Delete  Rule": "Delete  Rule",
  "Delete Device": "Delete Device",
  "English ": "English ",
  "Ok": "Ok",
  "Hi": "Hi",
  "Commandes": "Commandes",
  "Access Restricted Notice!": "Access Restricted Notice!",
  "Your License has expired. Please Contact your Admin.": "Your License has expired. Please Contact your Admin.",
  "Online": "Online",
  "Offline": "Offline",
  "Total": "Total",
  "Processing...": "Processing...",
  "Request Process Successfully": "Request Process Successfully",
  "Error occurred while processing request, please try again.": "Error occurred while processing request, please try again.",
  "Menu": "Menu",
  "Device Groups": "Device Groups",
  "HACCP Report": "HACCP Report",
  "Statistics": "Statistics",
  "Device List": "Device List",
  "All Devices": "All Devices",
  "Search works on Device, Groups, Alarms, Country columns": "Search works on Device, Groups, Alarms, Country columns",
  "Dongle UId": "Dongle UId",
  "Active": "Active",
  "InActive": "InActive",
  "Group(s)": "Group(s)",
  "Device Details": "Device Details",
  "View Value": "View Value",
  "Group Name": "Group Name",
  "Device Name": "Device Name",
  "Description": "Description",
  "Created Date (UTC)": "Created Date (UTC)",
  "Added By": "Added By",
  "Search works on Group Name, Description columns": "Search works on Group Name, Description columns",
  "Add Group Details": "Add Group Details",
  "Edit Group Details": "Edit Group Details",
  "Name of the Group": "Name of the Group",
  "Create New Group": "Create New Group",
  "Select Devices": "Select Devices",
  "Group Information": "Group Information",
  "Add Description": "Add Description",
  "Device Count": "Device Count",
  "Alarm Count": "Alarm Count",
  "Device Status": "Device Status",
  "Group Count": "Group Count",
  "Device by Group": "Device by Group",
  "Alarms By Device Status": "Alarms By Device Status",
  "Device Status Count": "Device Status Count",
  "Alarms By Devices Over Time": "Alarms By Devices Over Time",
  "Real Time": "Real Time",
  "Last 24 Hrs": "Last 24 Hrs",
  "Last Week": "Last Week",
  "Last Month": "Last Month",
  "Last 3 Months": "Last 3 Months",
  "Last 1 Year": "Last 1 Year",
  "Last 6 Months": "Last 6 Months",
  "Devices": "Devices",
  "OEM": "OEM",
  "Name": "Name",
  "OEM\/Parent": "OEM\/Parent",
  "Create Users": "Create Users",
  "Selected Countries": "Selected Countries",
  "Selected Devices": "Selected Devices",
  "Enabled": "Enabled",
  "Disabled": "Disabled",
  "Groups": "Groups",
  "Groups List": "Groups List",
  "Select Groups": "Select Groups",
  "Telemetry": "Telemetry",
  "Filters": "Filters",
  "Show Favorites": "Show Favorites",
  "Favorites": "Favorites",
  "Label": "Label",
  "Current Value": "Current Value",
  "Operations": "Operations",
  "Read All": "Read All",
  "Settings": "Settings",
  "Set Value": "Set Value",
  "Mobile UId": "Mobile UId",
  "Mobile OS | Version": "Mobile OS | Version",
  "Issued On": "Issued On",
  "Active Device(s)": "Active Device(s)",
  "In-active Device(s)": "In-active Device(s)",
  "Block User": "Block User",
  "Unblock User": "Unblock User",
  "Driver Upload": "Driver Upload",
  "Search works on Driver File Name, Mask, and Uploaded By columns": "Search works on Driver File Name, Mask, and Uploaded By columns",
  "Add new report": "Add new report",
  "Report Name": "Report Name",
  "Report Frequency": "Report Frequency",
  "Daily": "Daily",
  "Weekly": "Weekly",
  "Monthly": "Monthly",
  "Data Frequency": "Data Frequency",
  "PDF": "PDF",
  "CSV": "CSV",
  "XLSX": "XLSX",
  "Delete Report :": "Delete Report :",
  "Add Report": "Add Report",
  "Update Report Details": "Update Report Details",
  "Select Data Frequency": "Select Data Frequency",
  "One time per day": "One time per day",
  "Two times per day": "Two times per day",
  "Three time per day": "Three time per day",
  "Four times per day": "Four times per day",
  "Select Device": "Select Device",
  "Data Frequency is Mandatory": "Data Frequency is Mandatory",
  "Device is Mandatory": "Device is Mandatory",
  "Resource is Mandatory": "Resource is Mandatory",
  " Notified to email is Mandatory": " Notified to email is Mandatory",
  "Maximum 8 resources can be selected": "Maximum 8 resources can be selected",
  "Invalid OEM": "Invalid OEM",
  "Select an OEM": "Select an OEM",
  "User already exist": "User already exist",
  "Email or Role is not valid": "Email or Role is not valid",
  "You are currently blocked. Please contact system administrator for details or to restore access. <System Admin EMAIL ID>": "You are currently blocked. Please contact system administrator for details or to restore access. <System Admin EMAIL ID>",
  "Invalid Device": "Invalid Device",
  "Invalid Group": "Invalid Group",
  "Error Deleting Alarm Rule": "Error Deleting Alarm Rule",
  "Are you sure to Block ?": "Are you sure to Block ?",
  "Are you sure to Unblock ?": "Are you sure to Unblock ?",
  "Error downloading driver file": "Error downloading driver file",
  "Group deleted successfully": "Group deleted successfully",
  "Failed to delete group": "Failed to delete group",
  "Group created successfully": "Group created successfully",
  "Group details updated successfully": "Group details updated successfully",
  "Failed to create\/edit group": "Failed to create\/edit group",
  "Group Name already exist": "Group Name already exist",
  "Group Name already exist\/duplicate Group Name": "Group Name already exist\/duplicate Group Name",
  "Model is not valid": "Model is not valid",
  "Name\/Desc is not valid": "Name\/Desc is not valid",
  "One\/More selcted device is invalid or the user doesn't have access": "One\/More selcted device is invalid or the user doesn't have access",
  "User has no access to the group": "User has no access to the group",
  "Failed to fetch data": "Failed to fetch data",
  "Error deleting file ": "Error deleting file ",
  "Error occurred while adding\/updating Report, please try again.": "Error occurred while adding\/updating Report, please try again.",
  "Are you sure to Delete Report?": "Are you sure to Delete Report?",
  "Error Deleting Report": "Error Deleting Report",
  "User has no access to the Haccp Report": "User has no access to the Haccp Report",
  "Report name is not valid": "Report name is not valid",
  "Invalid Controller type": "Invalid Controller type",
  "Duplicate report name": "Duplicate report name",
  "Support": "Support",
  "FAQ's": "FAQ's",
  "Add OEM": "Add OEM",
  "History": "History",
  "v3.2": "v3.2",
  "Terms and Conditions": "Terms and Conditions",
  "Search works on OID,OEM Name,OEM Description": "Search works on OID,OEM Name,OEM Description",
  "OEM Description": "OEM Description",
  "OEM Name": "OEM Name",
  "OID": "OID",
  "Count": "Count",
  "Commands": "Commands",

  "Labels": "English",
  "Added On": "Added On",
  "Modbus slave ID": "Modbus slave ID",
  "Controller Type Name": "Controller Type Name",
  "Device Type": "Device type",
  "Groups Count": "Groups Count",
  "Day": "Day",
  "Hour": "Hour",
  "Start": "Start",
  "End": "End",
  "Poli": "Poli",
  "Search works on Report Name,Report Frequency, and Notified Email columns": "Search works on Report Name,Report Frequency, and Notified Email columns",
  "Release": "Release",
  "PCH": "PCH",
  "Location": "Location",
  "Dsp Id": "Dsp Id",
  "Firmware Version": "Firmware Version",
  "Device Metadata": "Device Metadata",
  "Alarms count by device's status": "Alarms count by device's status",
  "Alarms count group by device's status and device": "Alarms count group by device's status and device",
  "Alarm Count distribution over time": "Alarm Count distribution over time",
  "Alarm status count over time": "Alarm status count over time",
  "Device by Controller Model": "Device by Controller Model",
  "Select columns": "Select columns",
  "columns selected": "columns selected",
  "Favourites": "Favourites",
  "Language Selection": "Language Selection",
  "Select Language": "Select Language"

}
